<template>
  <TemplateView>
    <v-container>
      <router-view v-if="$route.name.includes('Show')"/>
      <template v-else>
        <div class="d-flex flex-wrap mb-8">
          <BaseButton
            v-for="(page, p) in list"
            :key="'finance_' + p"
            :text="page.text"
            style-type="chip"
            :disabled="$route.name === page.toName || $route.name === page.toName + 'Edit'"
            @click="$router.push({ name: page.toName })"
          />
        </div>
        <router-view />
      </template>
    </v-container>
  </TemplateView>
</template>

<script>
import TemplateView from "../../../components/templates/TemplateView";
import BaseButton from "../../../components/base/BaseButton";

export default {
  name: "salary",
  components: {BaseButton, TemplateView},
  computed: {
    list() {
      return [
        {
          toName: 'financeSalaryList',
          text: this.localStorage.translations.pages.finance.pages['list'],
          if: true,
        },
        {
          toName: 'financeSalarySlice',
          text: this.localStorage.translations.pages.finance.pages['salary-slice'],
          if: true,
        },
        {
          toName: 'financeSalaryManual',
          text: this.localStorage.translations.pages.finance.pages['salary-manual'],
          if: true,
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}
</style>
